export default __webpack_public_path__ + "static/media/section4-left.c1a33e40.png";